import { ConditionParams } from "@multiweb/clients/dataReader";
import { ActionContext, ActionType, IAction, IMultiObjectAction, SelectionType } from "../../../../UI.Controls/Actions/IAction";
import { IMultiselectComponent } from "../Frames/FrameInterfaces";
import { XGAction } from "./XGAction";

/** Akce, zobrazovaná v případě více vybraných záznamů zároveň */
export class MultiObjectAction extends XGAction implements IMultiObjectAction {
    private readonly _mainAction: XGAction;

    public get mainAction(): IAction {
        return this._mainAction;
    }

    public override get actionType(): ActionType {
        return this._mainAction.actionType;
    }

    public override get supportedSelectionModes(): SelectionType {
        return SelectionType.multi;
    }

    public override get context(): ActionContext {
        return ActionContext.frameAction;
    }

    constructor(action: XGAction) {
        super({ element: action.element, originalRightsDefinition: action.originalRightsDefinition });

        this._mainAction = action;
        this.masterNode = this._mainAction.masterNode;
        this.priority = this._mainAction.priority;
        this.toMenu = this._mainAction.toMenu;
        this.owner = this._mainAction.owner;
    }

    public override async execute(): Promise<void> {
        if (this.owner instanceof IMultiselectComponent) {
            let condition: string;
            let conditionParams: ConditionParams;
            const { isSelectedAll } = this.owner;

            let ids: string[];
            if (isSelectedAll) {
                ids = this.owner.unselectedIds;
                condition = this.owner.loadingCondition;
                conditionParams = this.owner.loadingConditionParams;
                if (ids.length > 0) {
                    condition = condition + ` AND (not (ID in { ${ids} }))`;
                }
            } else {
                ids = this.owner.selectedIds;
            }

            if (isSelectedAll || ids.length > 0) {
                this._mainAction.execute({ ids, className: this.owner.objectName, isSelectedAll, condition, conditionParams });
            }
            return;
        }
        this._mainAction.execute();
    }

    /**
     * Vstupní bod pro spuštění provedení metody
     */
    protected override async _internalExecute(): Promise<void> {
        // Prázdná metoda
    }
}
